// removed by extract-text-webpack-plugin
module.exports = {"row":"PrimaryLinks-style__row__e1bd129f","item":"PrimaryLinks-style__item__e1bd129f","link":"PrimaryLinks-style__link__e1bd129f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LinkRow/PrimaryLinks-style.scss
// module id = ./src/components/Footer/LinkRow/PrimaryLinks-style.scss
// module chunks = 13